// Sizes are in rem, with pixel translations for mobile and not-mobile in comments
export const FontSizes = {
	sm: 0.75, // 12px / 13.5px / small
	base: 1, // 16px / 18px / headline / body
	lg: 1.25, // 20px / 22.5px / title2
	xl: 1.5, // 24px / 27px // TODO: potentially deprecate
	'2xl': 1.75, // 28px / 31.5px / title1
	'3xl': 2.25, // 36px / 40.5px // TODO: potentially deprecate
	'4xl': 2.75, // 44px / 49.5px / hero
} as const;
export type FontSizeName = keyof typeof FontSizes;
export type FontSize = (typeof FontSizes)[FontSizeName];

// Font sizes that shift in rem value on mobile devices
export const MobileFontSizes: Record<FontSizeName, number | undefined> = {
	sm: undefined,
	base: undefined,
	lg: undefined,
	xl: undefined,
	'2xl': 1.5,
	'3xl': undefined,
	'4xl': undefined,
} as const;

export const FontWeights = {
	Light: 300,
	Regular: 400,
	Medium: 500,
	Demi: 700,
} as const;
export type FontWeight = (typeof FontWeights)[keyof typeof FontWeights];
